/**
 * @date 2022-01-24 14:10:39
 * @description 202200209版本【业务拓展需要新增会场收品，内含：活动报名和活动管理两个模块】
 * @param 活动报名和活动管理
 * @returns 会场收品【活动列表和收品池列表融合的双table】
 */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Input, Form, DatePicker, Select, Popover, Tooltip } from 'antd';
import { SettingOutlined, QuestionCircleOutlined, PlusOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import moment from 'moment';
import StarAndManageWrapper from '../star-and-manage-wrapper';
import ActivityListTable from '../activity-list-table';
import { connect } from 'react-redux';
import { ActivityReceiptContext, JoinAndManageContext } from './../../activity-receipt-context';
import {
  ACTIVITYRECEIPTTYPEENUM,
  STARANDMANAGETYPEENUM,
  APPLYVALIDSTATUSENUM,
  MYFOLLOWKEYNUM,
  ONLINEFLAGENUM,
  EXTFIELDSENUM,
  ORDERBYENUM,
} from './../../activity-receipt-config';
import { gotoNewBuildActivity } from './../../activity-receipt-jump';
import apis from './../../apis';
import goto from '@/common/goto';
import './index.less';
import FilterBoxes from '@/components/filter-new-boxes';

/* 活动列表请求的原始默认配置 */
const optionsTables = {
  page: 1,
  pageSize: 10,
  orderBy: ORDERBYENUM.BEGIN_TIME_DESC.key,
};
const optionsForm = {
  activityIdStr: '',
  name: '',
  onlineFlag: ONLINEFLAGENUM.RUNNING.key,
  beginAndEndTime: ['', ''],
};
const optionsCommon = {
  activeGroupItemChosed: null,
  activityType: '',
  applyValidStatus: APPLYVALIDSTATUSENUM.NOAPPLY.key, //不传全部，待报名传1，已报名传2
};
const initOptions = { ...optionsTables, ...optionsForm, ...optionsCommon };

function ActivityJoinAndManage(props) {
  const [activeTab] = useContext(ActivityReceiptContext);
  const [applyValidStatus, setApplyValidStatus] = useState(APPLYVALIDSTATUSENUM.NOAPPLY.key); // 初始化活动状态
  const [activeGroupItemChosed, setActiveGroupItemChosed] = useState(null); // 我的分组【我的关注及自己建的分组】
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [groupList, setGroupList] = useState([]); // 分组及数字
  const [activityTableList, setActivityTableList] = useState(null); // 获取活动table数据
  const [activityExtFieldsObj, setActivityExtFieldsObj] = useState({}); // 活动列表额需要请求的异步外拓展的字段数据
  const [activityTableListLoading, setActivityTableListLoading] = useState(false);

  const [actFilterForm] = Form.useForm();
  const [options, setOptions] = useState({ ...initOptions });

  useEffect(() => {
    actFilterForm?.resetFields();
    setApplyValidStatus(APPLYVALIDSTATUSENUM.NOAPPLY.key);
    setActiveGroupItemChosed(null);
    setActivityTableList(null);
    setActivityExtFieldsObj({});
    setActivityTableListLoading(false);
    setGroupList([]);
    setOptions({
      ...initOptions,
      scene: activeTab,
    });
  }, [activeTab, actFilterForm]);

  const memoizedGetGroupList = useCallback(
    async (mountedRef) => {
      if (activeTab === ACTIVITYRECEIPTTYPEENUM.APPLY.key) {
        const {
          data: { data: allData },
        } = await apis.fetchaActivityCollectionAll();

        // 如果被卸载就丢弃当前数据
        if (!mountedRef.current) return;

        if (allData && Array.isArray(allData) && allData.length > 0) {
          //将```groupId=-1的我的关注```过滤到第一位
          const followIndex = allData.findIndex((item) => item.groupId === MYFOLLOWKEYNUM);
          const followItem = allData.find((item) => item.groupId === MYFOLLOWKEYNUM);
          let newdata = [...allData];
          newdata.splice(followIndex, 1);
          newdata = [followItem, ...newdata];
          setGroupList(newdata);
        }
      }
    },
    [activeTab]
  );

  useEffect(() => {
    const mountedRef = { current: true };

    memoizedGetGroupList(mountedRef);

    return () => {
      mountedRef.current = false;
    };
  }, [memoizedGetGroupList]);

  /* *********************************************************************
   **************************** 获取主列表数据 ****************************
   ********************************************************************* */
  /* 驱动子组件调取api获取数据的唯一途径 */
  const memoizedGetActTableList = useCallback(
    async (mountedRef) => {
      if (!options.scene) return false;

      setActivityTableListLoading(true);
      // 格式化请求参数
      function formatParamsUtil(options) {
        let newOptions = { ...options };
        newOptions.onlineFlag = ONLINEFLAGENUM[newOptions.onlineFlag].postVal;
        newOptions.minBeginTime =
          (newOptions?.beginAndEndTime || ['', ''])[0] &&
          moment(newOptions.beginAndEndTime[0]).format('YYYY-MM-DD HH:mm:ss');
        newOptions.maxBeginTime =
          (newOptions?.beginAndEndTime || ['', ''])[1] &&
          moment(newOptions.beginAndEndTime[1]).format('YYYY-MM-DD HH:mm:ss');
        delete newOptions?.beginAndEndTime;

        if (newOptions.scene === ACTIVITYRECEIPTTYPEENUM.MANAGE.key) {
          newOptions.isWatch = null;
          newOptions.groupId = null;
          newOptions.applyValidStatus = null;
        } else {
          // isWatch: '', //空：全部,1-不关注,0-我关注的
          // groupId: -1, //-1:全部; -2:未分组; 其它：正常传分组ID
          // 二者互斥，在一个接口返回
          const activeGroupChosedCopy = newOptions.activeGroupItemChosed;
          newOptions.isWatch = activeGroupChosedCopy === MYFOLLOWKEYNUM ? 0 : null;
          newOptions.groupId =
            activeGroupChosedCopy === '' || activeGroupChosedCopy === null || activeGroupChosedCopy === undefined
              ? -1
              : activeGroupChosedCopy === MYFOLLOWKEYNUM
              ? -1
              : activeGroupChosedCopy;
          delete newOptions?.activeGroupItemChosed;

          newOptions.applyValidStatus = APPLYVALIDSTATUSENUM[newOptions.applyValidStatus].postVal;
        }
        return newOptions;
      }
      const formatParams = formatParamsUtil(options);
      let tableData = null;
      try {
        const { data } = await apis.fetchActivityPage({ ...formatParams });

        // 如果被卸载就丢弃当前数据
        if (!mountedRef.current) return;

        tableData = data;
        if (data) {
          setActivityTableList(tableData);
        } else {
          setActivityTableList([]);
        }
        setActivityTableListLoading(false);
      } catch (error) {
        setActivityTableList([]);
        setActivityTableListLoading(false);
        console.log(error);
      }

      /* 拓展字段 */
      try {
        if (tableData) {
          const { items } = tableData;
          const activityIdsArr = [];
          if (items && Array.isArray(items) && items.length > 0) {
            items.forEach((item) => {
              const { baseInfo } = item;
              activityIdsArr.push(baseInfo?.id);
            });
          }
          if (!(activityIdsArr.length > 0)) {
            return false;
          }
          const activityIds = activityIdsArr.join();
          const {
            data: { data: extData },
          } = await apis.fetchActivityExtFields({
            activityIds,
            scene: options.scene,
            fields: Object.keys(EXTFIELDSENUM).join(),
          });
          if (extData && Array.isArray(extData) && extData.length > 0) {
            // 这样保证每条数据和他对应的拓展数据都是一一对应的
            const extDataNewObj = extData?.reduce((total, item, index) => {
              const activityExtFieldsFormat = item?.infos?.reduce((ctotal, citem) => {
                return citem && citem?.key ? { ...ctotal, [citem.key]: citem.value } : { ...ctotal };
              }, {});
              return { ...total, [activityIdsArr[index]]: activityExtFieldsFormat };
            }, {});
            setActivityExtFieldsObj(extDataNewObj);
          } else {
            setActivityExtFieldsObj({});
          }
        }
      } catch (error) {
        setActivityExtFieldsObj({});
        console.log(error);
      }
    },
    [options]
  );
  useEffect(() => {
    const mountedRef = { current: true };

    memoizedGetActTableList(mountedRef);

    return () => {
      mountedRef.current = false;
    };
  }, [memoizedGetActTableList]);

  /* *********************************************************************
   **************************** 常规的事件监听 ****************************
   ********************************************************************* */
  /************* 切换状态 *************/
  function switchStatusType(applyValidStatus) {
    setApplyValidStatus(applyValidStatus);
    setOptions((pre) => ({ ...pre, applyValidStatus, page: 1 }));
  }
  function switchActiveGroupItemChosed(activeGroupItemChosedNew = null) {
    setActiveGroupItemChosed(activeGroupItemChosedNew);
    setOptions((pre) => ({ ...pre, activeGroupItemChosed: activeGroupItemChosedNew, page: 1 }));
  }
  function resetFetchData() {
    actFilterForm.resetFields();
    setOptions((pre) => {
      return {
        ...initOptions,
        applyValidStatus: pre?.applyValidStatus,
        activeGroupItemChosed: pre?.activeGroupItemChosed,
        orderBy: pre?.orderBy,
        scene: activeTab,
      };
    });
  }
  /************* 以下活动列表一级table相关 *************/
  /* 开始查询 */
  function onFilterFinish(values) {
    setActivityTableList(null);
    setActivityExtFieldsObj({});
    setOptions((pre) => {
      return { ...pre, ...optionsTables, orderBy: pre?.orderBy, ...values };
    });
  }

  function operationCallback(type, data) {
    switch (type) {
      case 'PAGINATIONCHANGE':
        setOptions((pre) => ({ ...pre, ...data }));
        break;

      case 'SORTERORDERCHANGE':
        setOptions((pre) => ({ ...pre, orderBy: data.currentOrder }));
        break;

      case 'ONCLICKCOPYRESULT':
        setOptions((pre) => ({ ...pre }));
        break;

      default:
        break;
    }
  }

  /* 创建活动 */
  function createActivity() {
    if (props.oldDailyActivity && props.oldDailyActivity == 1) {
      gotoNewBuildActivity();
    } else {
      // 新版创建活动
      goto.myCreateCreateRoomActivity().newTab();
    }
  }

  return (
    <JoinAndManageContext.Provider value={[groupList, memoizedGetGroupList]}>
      <div className="activity-join-container">
        {/* 筛选器 */}
        <div className="activity-join-filter-fa">
          <div className="activity-filter">
            {/* 筛选条件-状态 */}
            {activeTab === ACTIVITYRECEIPTTYPEENUM.APPLY.key ? (
              <div className="applied-status-fa">
                <div className="applied-status-key-fa common-filter-key">报名状态：</div>
                <div className="applied-status-val-fa">
                  {Object.values(APPLYVALIDSTATUSENUM) &&
                    Object.values(APPLYVALIDSTATUSENUM)?.map((item) => {
                      return (
                        <span
                          key={item.key}
                          className={classnames(
                            item.key === applyValidStatus ? 'common-filter-val-choosed' : 'common-filter-val',
                            'applied-status-item'
                          )}
                          onClick={() => switchStatusType(item.key)}
                        >
                          {item.name}
                        </span>
                      );
                    })}
                </div>
              </div>
            ) : null}
            {/* 筛选条件-常规条件 */}
            <FilterBoxes
              resetButtonProps={{
                onClick: () => resetFetchData(),
              }}
              form={actFilterForm}
              onFinish={onFilterFinish}
              initialValues={optionsForm}
              style={{ marginBottom: '20px' }}
            >
              <Form.Item name="name" label="活动名称" span={5} colon={false}>
                <Input placeholder="搜索活动名称" />
              </Form.Item>
              <Form.Item name="activityIdStr" label="活动编号" span={4} colon={false}>
                <Input placeholder="搜索活动编号" />
              </Form.Item>
              <Form.Item name="beginAndEndTime" label="活动时间" span={6} colon={false}>
                <DatePicker.RangePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
              </Form.Item>
              <Form.Item name="onlineFlag" label="活动状态" span={4} colon={false}>
                <Select placeholder="请选择活动状态" className="all-about-me-signed-activity-select">
                  {Object.values(ONLINEFLAGENUM) &&
                    Object.values(ONLINEFLAGENUM)?.map((item) => {
                      return (
                        <Select.Option value={item.key} key={item.key}>
                          {item.name}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </FilterBoxes>

            {/* 筛选条件-我的分组及新建按钮 */}
            <>
              {activeTab === ACTIVITYRECEIPTTYPEENUM.APPLY.key ? (
                <div className="applied-group-fa">
                  <div className="applied-group-key-fa common-filter-key">我的分组：</div>
                  <div className="applied-group-setting-fa common-filter-key">
                    <Popover
                      content={
                        <StarAndManageWrapper
                          modalType={STARANDMANAGETYPEENUM.MANAGETYPE}
                          groupList={groupList}
                          isModalVisible={isModalVisible}
                          setIsModalVisible={setIsModalVisible}
                        />
                      }
                      title={
                        <>
                          <span style={{ marginRight: '5px' }}>分组管理</span>
                          <Tooltip placement="top" title={`新建分组后，可将活动收藏到分组。每个用户最多新建10个分组。`}>
                            <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
                          </Tooltip>
                        </>
                      }
                      trigger="click"
                      placement="right"
                      overlayClassName="star-and-manage-wrapper"
                      overlayStyle={{ width: '210px' }}
                      destroyTooltipOnHide={true}
                      visible={isModalVisible}
                      onVisibleChange={(bol) => setIsModalVisible(bol)}
                    >
                      <SettingOutlined className="icon-i" />
                    </Popover>
                  </div>
                  <div className="applied-group-val-fa">
                    <span
                      className={classnames(
                        activeGroupItemChosed === null ? 'common-filter-val-choosed' : 'common-filter-val',
                        'applied-group-item'
                      )}
                      onClick={() => switchActiveGroupItemChosed()}
                    >
                      全部
                    </span>
                    {groupList &&
                      groupList.length > 0 &&
                      groupList.map((item, index) => {
                        return (
                          <span
                            className={classnames(
                              item.groupId === activeGroupItemChosed
                                ? 'common-filter-val-choosed'
                                : 'common-filter-val',
                              'applied-group-item'
                            )}
                            key={index}
                            onClick={() => switchActiveGroupItemChosed(item?.groupId)}
                          >
                            {/* {`${item.name}（${item?.count || '0'}）`} */}
                            {`${item.name}`}
                          </span>
                        );
                      })}
                  </div>
                </div>
              ) : null}
              {activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key && (
                <div className="applied-group-new-build-fa">
                  <div className="applied-group-new-build-txt">
                    共<span className="group-all-count">{activityTableList?.totalCount || '0'}</span>条
                  </div>
                  <div className="applied-group-new-build" onClick={createActivity}>
                    <PlusOutlined className="new-build-icon" />
                    新建活动
                  </div>
                </div>
              )}
            </>
          </div>
        </div>

        {/* table主体 */}
        <ActivityListTable
          activeTab={activeTab}
          groupList={groupList}
          activityTableList={activityTableList}
          activityExtFieldsObj={activityExtFieldsObj}
          activityTableListLoading={activityTableListLoading}
          operationCallback={operationCallback}
        />
      </div>
    </JoinAndManageContext.Provider>
  );
}

export default connect((state) => {
  if (!state.userInfo.permissions || state.userInfo.permissions.oldDailyActivity === undefined) return {};
  return {
    oldDailyActivity: state.userInfo.permissions.oldDailyActivity,
  };
})(ActivityJoinAndManage);
